import { render, staticRenderFns } from "./DeyeProducerComponentSettings.vue?vue&type=template&id=79792490&"
import script from "./DeyeProducerComponentSettings.vue?vue&type=script&lang=ts&"
export * from "./DeyeProducerComponentSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports